import React, {Component} from 'react';

class TitleListHotels extends Component {


  render() { 

    return (
        <div className="cntered-flex ">
            <div className="hp_main_title_grid_rows_container">
                <div className="hp_main_title_top_pad" ></div>
                <div className="hp_main_title_grid_container">
                    <div className="hp_main_title_line_div">
                        <span className="hp_main_title_line"></span>
                    </div>
                    <div className="hp_main_title_container">
                        {this.props.titleListHotels}
                    </div>
                    <div className="hp_main_title_line_div">
                    <span className="hp_main_title_line"></span>
                    </div>
                </div>

                <div className="hp_main_title_bottom_pad" ></div>
            </div>
        </div>	        
    )
  }
}

export default TitleListHotels;
